import { Container, Row, Col } from "reactstrap";

import LandingPageHeader from "../../components/Header/LandingPageHeader";
import PagesFooter from "components/Footer/PagesFooter";

const SiteMap = () => {
  return (
    <>
      <LandingPageHeader />
      <Container>
        <Row>
          <Col className="ml-auto mr-auto" md="12">
            <ul className="breadcrumb-links">
              <li>
                <a href="/">Strona główna </a>
              </li>
              <li>Mapa strony</li>
            </ul>
          </Col>
        </Row>
      </Container>
      <div className="section landing-section">
        <Container>
          <Row>
            <Col className="ml-auto mr-auto" md="12">
              <h1 className="title text-center">
                <strong style={{ color: "#17728d" }}>Mapa strony</strong>
              </h1>
              <ul className={"site-links"}>
                <li>
                  <a href={"/"}>Strona główna</a>
                </li>
                <li>
                  <a href={"/admin/main_page"}>Logowanie/Rejestracja</a>
                </li>
                <li>
                  <a href={"/regulaminSerwisu"}>Regulamin serwisu</a>
                </li>
                <li>
                  <a href={"/privacypolicy"}>Polityka prywatności</a>
                </li>
                <li>
                  <a href={"/wcag"}>Dostępność cyfrowa</a>
                </li>
                <li>
                  <a href={"/mapa-strony"}>Mapa strony</a>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
      <PagesFooter />
    </>
  );
};

export default SiteMap;
